import { getPermissions } from "@/helper/collection";

export const ExhibitorRoutes = {
  path: "/cinema-manager",
  name: "Exhibitor Management",
  redirect: "/cinema-manager",
  component: {
    render(c) {
      return c("router-view");
    }
  },
  children: [
    {
      path: "/",
      name: "",
      component: () =>
        import("@/components/Pages/CinemaContainer/cinemaMasters.vue"),
      meta: {}
    },
    // AccessRightsForSchedule.vue
    // {
    //   path: "access-rights-for-schedule",
    //   name: "Access Rights For Schedule",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/AccessRightsComponents/AccessRightsForSchedule"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       12,
    //       2
    //     )
    //   }
    // },
    // // AccessRightsForFnB.vue
    // {
    //   path: "payment-credential",
    //   name: "Payment Credential",
    //   component: () => import("@/components/NewSignage/payment_credential.vue"),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       12,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "access-rights-for-fnb",
    //   name: "Access Rights For Food and Beverages",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/AccessRightsComponents/AccessRightsForFnB"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       186,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "feedback-forms",
    //   name: "Feedback Forms",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/FeedbackFormComponents/forms"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       138,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "add-form",
    //   name: "Add Form",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/FeedbackFormComponents/addForm"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       138,
    //       2
    //     )
    //   }
    // },
    // // {
    // //     path: "list-feedback-forms",
    // //     name: "List Forms",
    // //     component: () => import("@/components/Pages/ExhibitorManagement/SendFeedbackComponents/listFeedbackForms.vue"),
    // //     meta: {
    // //         permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '')
    // //     }
    // // },
    // {
    //   path: "send-feedback-form/:form_id",
    //   name: "Send Form",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/SendFeedbackComponents/sendFeedback.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       138,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "response-form",
    //   name: "Response Form",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/FeedbackFormComponents/responseForm"
    //     ),
    //
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       138,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "single-response-form/:form_id/:form_log_id",
    //   name: "Single Response Form",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/FeedbackFormComponents/singleResponse.vue"
    //     ),
    //
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       138,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "view-form",
    //   name: "View Form",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/FeedbackFormComponents/viewForm"
    //     ),
    //
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       138,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "shifts",
    //   name: "Shifts",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ShiftsComponents/shifts"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       11,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "add-shift",
    //   name: "Add Shift",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ShiftsComponents/addShift"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       11,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "edit-shift",
    //   name: "Edit Shift",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ShiftsComponents/editShift"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       11,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "view-shift",
    //   name: "View Shift",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ShiftsComponents/viewShift"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       11,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "user-shifts",
    //   name: "User Shifts",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/UsershiftsComponents/userShifts"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       13,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "add-users-shifts",
    //   name: "Add User Shifts",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/UsershiftsComponents/addUserShifts"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       13,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "edit-users-shifts",
    //   name: "Edit User Shifts",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/UsershiftsComponents/editUserShifts"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       13,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "view-users-shifts",
    //   name: "View User Shifts",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/UsershiftsComponents/viewUserShifts"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       13,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "reserve-seats-list",
    //   name: "Reserved Seats List",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ReserveSeatComponent/reserveSeatsList.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       22,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "reserve-seats",
    //   name: "Reserve Seats",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ReserveSeatComponent/reserveSeats.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       22,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "past-booking",
    //   name: "Past Booking",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ReserveSeatComponent/pastBooking.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       196,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "swap-auditorium/:ss_id/:md_id/:screen_id/:type",
    //   name: "Swap Auditorium",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/SwapAuditorium/swapAuditorium.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       196,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "merge-schedule/:ss_id/:md_id/:screen_id/:type",
    //   name: "Merge Schedule",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/SwapAuditorium/swapAuditorium.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       196,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "movies",
    //   name: "Movie",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/MoviesComponents/movies"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       14,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "edit-movies",
    //   name: "Edit Movie",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/MoviesComponents/editMovies"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       14,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "add-movies",
    //   name: "Add Movies",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/MoviesComponents/addMovies"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       14,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "view-movies",
    //   name: "View Movie",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/MoviesComponents/viewMovies"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       14,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "movie-rate-card",
    //   name: "Movie Rate Card",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/MovieRateCard/movieRateCards"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       197,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "edit-movie-rate-card",
    //   name: "Edit Movie Rate Card",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/MovieRateCard/editMovieRateCard"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       197,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "edit-tms",
    //   name: "Edit TMS ID",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/MoviesComponents/editTsm"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       14,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "cinemas",
    //   name: "Cinemas",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/CinemasComponents/cinemas.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       16,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "add-cinema",
    //   name: "Add Cinema",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/CinemasComponents/addCinema.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       16,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "edit-cinema",
    //   name: "Edit Cinema",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/CinemasComponents/editCinema.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       16,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "view-cinema",
    //   name: "View Cinema",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/CinemasComponents/viewCinema.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       16,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "cinema-settings",
    //   name: "Cinema Settings",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/CinemaSettingsComponents/cinemaSettings"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       15,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "add-cinema-settings",
    //   name: "Add Cinema Settings",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/CinemaSettingsComponents/addCinemaSettings"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       15,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "edit-cinema-settings",
    //   name: "Edit Cinema Settings",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/CinemaSettingsComponents/editCinemaSettings"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       15,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "view-cinema-settings",
    //   name: "View Cinema Settings",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/CinemaSettingsComponents/viewCinemaSettings"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       15,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "screens",
    //   name: "Screens",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/CinemasScreenComponents/cinemaScreens.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       17,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "add-screen",
    //   name: "Add Screen",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/CinemasScreenComponents/addScreens.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       17,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "edit-screen",
    //   name: "Edit Screen",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/CinemasScreenComponents/editScreens.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       17,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "view-screen",
    //   name: "View Screen",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/CinemasScreenComponents/viewScreens.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       17,
    //       1
    //     )
    //   }
    // },
    // // Screen Type
    // {
    //   path: "add-screen-type",
    //   name: "Add Screen Type",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ScreenTypeComponent/addScreenType.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       171,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "edit-screen-type",
    //   name: "Edit Screen Type",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ScreenTypeComponent/editScreenType.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       171,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "screen-type",
    //   name: "Screen Type",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ScreenTypeComponent/screenType.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       171,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "add-screen-size-format",
    //   name: "Add Screen Size Format",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ScreenSizeFormat/addScreenSizeFormat.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       172,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "edit-screen-size-format",
    //   name: "Edit Screen Size Format",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ScreenSizeFormat/editScreenSizeFormat.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       172,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "screen-size-format",
    //   name: "Screen Size Format",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ScreenSizeFormat/listScreenSizeFormat.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       172,
    //       1
    //     )
    //   }
    // },
    // // SEAT TYPE
    // {
    //   path: "seat-type",
    //   name: "Seat Type",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/SeatTypeComponents/seatType.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       139,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "add-seat-type",
    //   name: "Add Seat Type",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/SeatTypeComponents/addSeatType.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       139,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "edit-seat-type",
    //   name: "Edit Seat Type",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/SeatTypeComponents/editSeatType.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       139,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "view-seat-type",
    //   name: "View Seat Type",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/SeatTypeComponents/viewSeatType.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       139,
    //       1
    //     )
    //   }
    // },
    //
    // {
    //   path: "seat-layout",
    //   name: "Seat Layout",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/CinemaSeatLayoutComponents/seatLayout.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "HoManager", "CinemaManager"],
    //       false,
    //       "",
    //       18,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "add-seat-layout/:screenID",
    //   name: "Add Seat Layout",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/CinemaSeatLayoutComponents/addSeatLayout.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "HoManager", "CinemaManager"],
    //       false,
    //       "",
    //       18,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "edit-seat-layout/:screenID",
    //   name: "Edit Seat Layout",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/CinemaSeatLayoutComponents/editSeatLayout.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "HoManager", "CinemaManager"],
    //       false,
    //       "",
    //       18,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "view-seat-layout/:screenID",
    //   name: "View Seat Layout",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/CinemaSeatLayoutComponents/viewSeatLayout.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "HoManager", "CinemaManager"],
    //       false,
    //       "",
    //       18,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "broken-seat-layout/:screenID",
    //   name: "Broken Seat Layout",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/CinemaSeatLayoutComponents/brokenSeatLayout.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "HoManager", "CinemaManager"],
    //       false,
    //       "",
    //       18,
    //       1
    //     )
    //   }
    // },
    // //
    //
    // {
    //   path: "schedule2",
    //   name: "Schedules2",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ScheduleComponents/schedule2"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       21,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "addMultiSchedule",
    //   name: "Add Multiple Schedule",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/MultiScheduleComponents/addMultiSchedule"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       21,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "drag-and-drop-schedule",
    //   name: "Drag & Drop Schedule",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ScheduleComponents/ViewScheduleDD-1"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       21,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "view-schedule-dd",
    //   name: "View Drag & Drop Schedule",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ScheduleComponents/viewScheduleDD-2"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       21,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "view-schedule-overview",
    //   name: "View Schedule Overview",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ScheduleComponents/ViewScheduleOverview"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       21,
    //       1
    //     )
    //   }
    // },
    // // {
    // //     path: "scheduledd1old",
    // //     name: "scheduledd1old",
    // //     component: () => import("@/components/Pages/ExhibitorManagement/ScheduleComponents/ViewScheduleDD-1-old"),
    // //     meta: {
    // //         permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '', 21, 1)
    // //     }
    // // },
    // {
    //   path: "edit-schedule",
    //   name: "Edit Schedule",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ScheduleComponents/EditSchedule"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       21,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "view-schedule",
    //   name: "Schedule",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ScheduleComponents/viewScheduleDD-2"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "HoManager", "CinemaManager"],
    //       false,
    //       "",
    //       21,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "view-planned-schedule",
    //   name: "Planned Schedule",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/PlannedScheduleComponents/listplannedschedule"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "HoManager", "CinemaManager"],
    //       false,
    //       "",
    //       140,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "schedule-comments",
    //   name: "Schedule List",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ScheduleCommentsComponent/ScheduleList.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "HoManager", "CinemaManager"],
    //       false,
    //       "",
    //       141,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "schedule-transactions/:ss_id",
    //   name: "Schedule Transactions",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ScheduleCommentsComponent/ScheduleTransactions.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "HoManager", "CinemaManager"],
    //       false,
    //       "",
    //       141,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "schedule-seat-layout/:ss_id/:md_id/:screen_id",
    //   name: "Schedule Seat Layout",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ScheduleCommentsComponent/scheduleSeatLayout.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "HoManager", "CinemaManager"],
    //       false,
    //       "",
    //       141,
    //       1
    //     )
    //   }
    // },
    //
    // {
    //   path: "profile",
    //   name: "Profile",
    //   component: () => import("@/components/Pages/UserManagement/profile.vue"),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       ""
    //     )
    //   }
    // },
    //
    // {
    //   path: "tax-settings",
    //   name: "Tax Settings",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ChargeSettingComponents/chargeSetting"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       19,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "add-tax-setting",
    //   name: "Add Tax Setting",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ChargeSettingComponents/addChargeSetting"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       19,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "edit-tax-setting",
    //   name: "Edit Tax Setting",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ChargeSettingComponents/editChargeSetting"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       19,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "view-tax-setting",
    //   name: "View Tax Setting",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ChargeSettingComponents/viewChargeSetting"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       19,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "rateCard",
    //   name: "Rate Card",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/RatecardComponents/rateCard.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       20,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "addon_charges",
    //   name: "Movie Addon Charges",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/AddonCharges/addonCharges.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       202,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "private-rate-card",
    //   name: "Rate Card Group Beta",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/RatecardComponents/privateRateCard.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       188,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "add-rate-card",
    //   name: "Add Rate Card",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/RatecardComponents/addRateCard.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       20,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "edit-rate-card",
    //   name: "Edit Rate Card",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/RatecardComponents/editRateCard.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       20,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "view-rate-card",
    //   name: "View Rate Card",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/RatecardComponents/viewRateCard.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       20,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "list-private-rate-card",
    //   name: "Rate Card",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/RatecardComponents/listPrivateRateCard.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       188,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "add-rate-card-group",
    //   name: "Add Rate Card Group",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/RateCardGroupComponent/addRateCardGroup.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       166,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "edit-rate-card-group",
    //   name: "Edit Rate Card Group",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/RateCardGroupComponent/editRateCardGroup.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       166,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "view-rate-card-group",
    //   name: "View Rate Card Group",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/RateCardGroupComponent/listRateCardGroup.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       166,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "float-amount",
    //   name: "Float Amount",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/FloatAmountComponents/floatAmount"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "HoManager", "CinemaManager"],
    //       false,
    //       "",
    //       23,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "add-float-amount",
    //   name: "Add Float Amount",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/FloatAmountComponents/addFloatAmount"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "HoManager", "CinemaManager"],
    //       false,
    //       "",
    //       23,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "edit-float-amount",
    //   name: "Edit Float Amount",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/FloatAmountComponents/editFloatAmount"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "HoManager", "CinemaManager"],
    //       false,
    //       "",
    //       23,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "view-float-amount",
    //   name: "View Float Amount",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/FloatAmountComponents/viewFloatAmount"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "HoManager", "CinemaManager"],
    //       false,
    //       "",
    //       23,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "make-a-refund",
    //   name: "Make A refund",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/MakeARefund/makeARefund"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       25,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "payment-gateway-refund",
    //   name: "Payment Gateway Refund",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/PaymentGatewayRefund/PaymentGatewayRefund"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       25,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "refund",
    //   name: "Refund",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/RefundComponents/refund"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       26,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "add-refund",
    //   name: "Add Refund",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/RefundComponents/addRefund"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       26,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "edit-refund",
    //   name: "Edit Refund",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/RefundComponents/editRefund"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       26,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "view-refund",
    //   name: "View Refund",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/RefundComponents/viewRefund"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       26,
    //       1
    //     )
    //   }
    // },
    //
    // // show-transaction-refund
    // {
    //   path: "show-transaction-refund",
    //   name: "Show Transaction Refund",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/RefundComponents/showTransactions"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       26,
    //       1
    //     )
    //   }
    // },
    //
    // {
    //   path: "hardware-settings",
    //   name: "Hardware Device Setting",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/HardwaresComponents/hardwareSettings"
    //     ),
    //   //component: () => () => import('@/components/Pages/CinemaContainer/HardwaresComponents/hardwareSettings'),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       31,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "maccs-settings",
    //   name: "MACCS Setting",
    //   component: () =>
    //     import("@/components/Pages/ExhibitorManagement/Macs/macsSettings"),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       199,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "add-hardware-settings",
    //   name: "Add Hardware Settings",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/HardwaresComponents/addHardwareSettings"
    //     ),
    //   //component: () => () => import('@/components/Pages/CinemaContainer/HardwaresComponents/addHardwareSettings'),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       31,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "edit-hardware-settings",
    //   name: "Edit Hardware Settings",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/HardwaresComponents/editHardwareSetting"
    //     ),
    //   //component: () => () => import('@/components/Pages/CinemaContainer/HardwaresComponents/editHardwareSetting'),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       31,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "view-hardware-settings",
    //   name: "View Hardware Settings",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/HardwaresComponents/viewHardwareSettings"
    //     ),
    //   //component: () => () => import('@/components/Pages/CinemaContainer/HardwaresComponents/viewHardwareSettings'),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       31,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "shifts-close",
    //   name: "Shift Close Dashboard",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ShiftCloseComponent/shiftsClose"
    //     ),
    //   //component: () => () => import('@/components/Pages/CinemaContainer/HardwaresComponents/viewHardwareSettings'),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       24,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "edit-shift-close",
    //   name: "Edit Shift Close",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ShiftCloseComponent/editShiftClose"
    //     ),
    //   //component: () => () => import('@/components/Pages/CinemaContainer/HardwaresComponents/viewHardwareSettings'),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       24,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "update-shift-close",
    //   name: "Update Shift Close",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ShiftCloseComponent/updateShiftClose"
    //     ),
    //   //component: () => () => import('@/components/Pages/CinemaContainer/HardwaresComponents/viewHardwareSettings'),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       24,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "view-shift-close",
    //   name: "View Shift Close",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ShiftCloseComponent/viewShiftClose"
    //     ),
    //   //component: () => () => import('@/components/Pages/CinemaContainer/HardwaresComponents/viewHardwareSettings'),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       24,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "concession",
    //   name: "Concession",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ConcessionComponents/concession"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       28,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "add-concession",
    //   name: "Add Concession",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ConcessionComponents/addConcession"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       28,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "edit-concession",
    //   name: "Edit Concession",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ConcessionComponents/editConcession"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       28,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "view-concession",
    //   name: "View Concession",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ConcessionComponents/viewConcession"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       28,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "weekends",
    //   name: "Weekends",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/WeekendsComponents/weekends"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       29,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "add-weekends",
    //   name: "Add Weekends",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/WeekendsComponents/addWeekends"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       29,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "edit-weekends",
    //   name: "Edit Weekends",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/WeekendsComponents/editWeekends"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       29,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "signage-url",
    //   name: "Signage URL",
    //   component: () =>
    //     import("@/components/Pages/ExhibitorManagement/SignageUrl/signageUrl"),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       32,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "add-signage-url",
    //   name: "Add Signage URL",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/SignageUrl/addSignageUrl"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       32,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "edit-signage-url",
    //   name: "Edit Signage URL",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/SignageUrl/editSignageUrl"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       32,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "view-signage-url",
    //   name: "View Signage URL",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/SignageUrl/viewSignageUrl"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       32,
    //       1
    //     )
    //   }
    // },
    // //Signage Movie Mapping
    // {
    //   path: "signage-mapping",
    //   name: "Signage Mapping",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/SignageMovieMappingComponents/listSignagemoviemapping"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       64,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "add-signage-mapping",
    //   name: "Add Signage Mapping",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/SignageMovieMappingComponents/addSignagemoviemapping"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       64,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "edit-signage-mapping",
    //   name: "Edit Signage Mapping",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/SignageMovieMappingComponents/editSignagemoviemapping"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       64,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "release-seat",
    //   name: "Release Seat",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ReleaseSeat/releaseSeat.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       149,
    //       2
    //     )
    //   }
    // },
    //
    // {
    //   path: "customer-transactions",
    //   name: "Customer List Transactions",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/customerTransactionComponents/customerList.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       35,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "view-customer-transaction",
    //   name: "View Customer Transactions",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/customerTransactionComponents/customerTransactions.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       35,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "view-guest-transaction",
    //   name: "View Guest Transactions",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/customerTransactionComponents/guestTransactionDetail.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       35,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "schedule-print",
    //   name: "Schedule Print",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/SchedulePrintTransactionComponents/schedulePrint.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       36,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "list-checklists",
    //   name: "List Checklists",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ChecklistComponents/listChecklists.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       143,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "add-checklist",
    //   name: "Add Checklist",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ChecklistComponents/addChecklist.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       143,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "edit-checklist/:checklist_id",
    //   name: "Edit Checklist",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ChecklistComponents/editChecklist.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       143,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "view-checklist/:checklist_id",
    //   name: "View Checklist",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ChecklistComponents/viewChecklist.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       143,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "support-ticketing",
    //   name: "Support Ticketing",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/SupportTicketingComponents/listSupportTicketing.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       144,
    //       1
    //     )
    //   }
    // },
    // ,
    // {
    //   path: "add-support-ticketing",
    //   name: "Add Support Ticketing",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/SupportTicketingComponents/addSupportTicketing.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       144,
    //       2
    //     )
    //   }
    // },
    //
    // {
    //   path: "edit-support-ticketing",
    //   name: "Edit Support Ticketing",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/SupportTicketingComponents/editSupportTicketing.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       144,
    //       2
    //     )
    //   }
    // },
    //
    // {
    //   path: "view-support-ticketing",
    //   name: "View Support Ticketing",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/SupportTicketingComponents/viewSupportTicketing.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       144,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "fnb-audit-logs",
    //   name: "Audit Logs",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/FnbAuditLogComponents/listgFnBAuditLogs.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       147,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "schedule-audit-logs",
    //   name: "Schedule Audit Logs",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/ScheduleAuditLogComponents/listgScheduleAuditLogs.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       148,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "system-logs",
    //   name: "System Logs",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/SystemLogs/listSystemLogs.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       173,
    //       1
    //     )
    //   }
    // },
    // //FnB Dynamic Pricing
    // {
    //   path: "fnb-dynamic-pricing",
    //   name: "FnB Dynamic Pricing",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/FnbDynamicPricing/fnbDynamicPricing"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       158,
    //       1
    //     )
    //   }
    // },
    // {
    //   path: "add-fnb-dynamic-pricing",
    //   name: "Add FnB Dynamic Pricing",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/FnbDynamicPricing/addFnbDynamicPricing"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       158,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "edit-fnb-dynamic-pricing",
    //   name: "Edit FnB Dynamic Pricing",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/FnbDynamicPricing/editFnbDynamicPricing"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       158,
    //       2
    //     )
    //   }
    // },
    // {
    //   path: "view-fnb-dynamic-pricing",
    //   name: "View FnB Dynamic Pricing",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ExhibitorManagement/FnbDynamicPricing/viewFnbDynamicPricing"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       158,
    //       1
    //     )
    //   }
    // }
    // // {
    // //     path: 'payment-options',
    // //     name: 'Payment Options',
    // //     component: () => import('@/components/Pages/ExhibitorManagement/PaymentOptions/paymentOptions'),
    // //     meta: {
    // //         permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '', 0, 1)
    // //     }
    // // },
  ]
};



// WEBPACK FOOTER //
// ./src/router/exhibitorRoutes.js